import React from "react";
import PropTypes from "prop-types";
import {makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import clsx from "clsx";
import Tr from "translations/Translations";
import BzpResultNoticeRow from "./BzpResultNoticeRow";

const useStyles = makeStyles(theme => ({
    table: {
        tableLayout: 'fixed',
        '& td, th': {
            overflow: 'hidden',
        }
    },
    buttonColumn: theme.components.table.buttonColumn,
    dateColumn: theme.components.table.dateTimeColumn
}))

function BzpResultNotice(
    {
        demandId,
        editable,
        resultNotices,
        bzpResultNoticeSend,
        bzpResultNoticePublishedOnEzamowienia,
    }) {
    const classes = useStyles();

    return (<>
            <TableContainer>
                {!!resultNotices && <Table className={clsx(classes.table)}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{Tr("name")}</TableCell>
                            <TableCell className={classes.dateColumn}>{Tr("add_data")}</TableCell>
                            <TableCell className={classes.dateColumn}>{Tr("publish_data")}</TableCell>
                            <TableCell className={classes.buttonColumn}></TableCell>
                            <TableCell className={classes.buttonColumn}></TableCell>
                            <TableCell className={classes.buttonColumn}></TableCell>
                            <TableCell className={classes.buttonColumn}></TableCell>
                            <TableCell className={classes.buttonColumn}></TableCell>
                            <TableCell className={classes.buttonColumn}></TableCell>
                            <TableCell className={classes.buttonColumn}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!!resultNotices && resultNotices.filter(resultNotice => resultNotice.attachments !== null && resultNotice.attachments.length > 0).map((resultNotice, i) => (
                            <BzpResultNoticeRow
                                key={resultNotice.attachments[0].identity}
                                editable={editable}
                                updateExists={resultNotices.some(notice => notice.update)}
                                demandId={demandId}
                                resultNotice={resultNotice}
                                bzpResultNoticeSend={bzpResultNoticeSend}
                                bzpResultNoticePublishedOnEzamowienia={bzpResultNoticePublishedOnEzamowienia}
                                attachment={resultNotice.attachments[0]}
                                disabled={i !== 0}
                            />

                        ))}
                    </TableBody>
                </Table>}
            </TableContainer>
        </>
    )
}

BzpResultNotice.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    resultNotices: PropTypes.arrayOf(PropTypes.object.isRequired),
    bzpResultNoticeSend: PropTypes.bool.isRequired,
    bzpResultNoticePublishedOnEzamowienia: PropTypes.bool.isRequired,
}


export default BzpResultNotice;